export const environment = 'stg'

export const tradingApi = 'https://api.stg.rhino.fi'

export const multiCallDoNotAggregate = ['BINANCE']

export const LEGACY_RHINO_CLAIMS = {
  TAIKO: [1, 3, 4],
}

export const LEGACY_CROSS_CHAIN_SWAP_CONTRACTS = [
  { chain: 'ARBITRUM_MAINNET', contractAddress: '0x9205d39ddee10cc23dcbcb936be65d664c8a31d1' },
  { chain: 'BINANCE_MAINNET', contractAddress: '0x65a4b8a0927c7fd899aed24356bf83810f7b9a3f' },
  { chain: 'POLYGON_MAINNET', contractAddress: '0xa277c4848065F0af95435C181AAd1962A5EC0255' },
]
